import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // material ui component

import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { LIST_PROP, SIMPLE_VALUE_PROP } from './consts/prop-types'; // import { wireValue } from '../prop-wire'

import { wireValue } from './hoc/prop-wire';
/**
 * A React (single-select) DropDown List
 * @constructor
 * @param {string} [id] - Input element #id
 * @param {string} [name] - Input element name
 * @param {number} [size=1] - Number of items to display
 * @param {Array.<object>} list - List of items
 * @param {string | number} list.value - item value
 * @param {string} list.text - item display text
 * @param {string} [className] - Classname for the container
 * @param {string} [defaultText] - Default text to display when nothing is selected
 * @param {string|number} [defaultValue] - Default selected value
 * @param {string|number} [value] - Current selected value
 * @param {object} [valueLink] - Link to update value. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} valueLink.value - value to update
 * @param {function} valueLink.requestChange - function to request value change
 * @param {boolean} [required=false] - Is this field mandatory?
 * @param {boolean} [disabled=false] - Is this field disabled?
 * @param {boolean} [readOnly=false] - Is this field readonly?
 * @param {function} [onChange] - Callback function when item is selected. <br> Required when value prop is supplied
 * @param {string|number} onChange.value - selected value
 * @param {object} onChange.eventInfo - event related info
 * @param {string|number} onChange.eventInfo.before - previously selected value
 *
 * @example
 *
 */

var CssTextField = withStyles({
  root: {
    '& .Mui-focused > select': {
      backgroundColor: '#fff',
      borderRadius: '4px'
    },
    '& .MuiInputBase-root': {
      fontSize: 'inherit'
    },
    '& .MuiInputBase-root > select': {
      height: '35px'
    }
  }
})(TextField);

var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (evt) {
      var onChange = _this.props.onChange;
      onChange(evt.target.value);
    });

    return _this;
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          size = _this$props.size,
          list = _this$props.list,
          value = _this$props.value,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          required = _this$props.required,
          defaultText = _this$props.defaultText,
          variant = _this$props.variant,
          native = _this$props.native,
          className = _this$props.className,
          label = _this$props.label,
          style = _this$props.style,
          helperText = _this$props.helperText,
          isFullWidth = _this$props.isFullWidth,
          width = _this$props.width;
      var found = false;

      if (value != null) {
        found = _.find(list, function (item) {
          return "".concat(item.value) === "".concat(value);
        });
      }

      return /*#__PURE__*/React.createElement(CssTextField, {
        className: className,
        select: true,
        fullWidth: isFullWidth,
        id: id,
        name: name,
        error: !found && required,
        onChange: readOnly ? null : this.handleChange,
        required: required,
        value: value,
        readOnly: readOnly,
        disabled: readOnly || disabled,
        variant: variant,
        size: size,
        SelectProps: {
          native: true
        },
        style: {
          width: width
        },
        label: label,
        helperText: helperText
      }, (!found || !required) && /*#__PURE__*/React.createElement("option", {
        key: "_",
        value: ""
      }, defaultText || ''), _.map(list, function (_ref) {
        var itemValue = _ref.value,
            itemText = _ref.text;
        return /*#__PURE__*/React.createElement("option", {
          key: itemValue,
          value: itemValue
        }, itemText);
      }));
    }
  }]);

  return Dropdown;
}(React.Component);

Dropdown.propTypes = {
  style: PropTypes.object,
  id: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
  list: LIST_PROP,
  className: PropTypes.string,
  defaultText: SIMPLE_VALUE_PROP,
  value: SIMPLE_VALUE_PROP,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  native: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  onChange: PropTypes.func,
  width: PropTypes.string
};
Dropdown.defaultProps = {
  required: false,
  disabled: false,
  readOnly: false,
  variant: 'outlined',
  isFullWidth: false
};
export default wireValue(Dropdown); // export default wireValue(normalizeList(Dropdown));